import React from "react"

export default function QuickActionSheet({
  open,
  onClose,
  eyebrow,
  title,
  subtitle,
  children,
  width = 520
}) {
  if (!open) return null

  return (
    <div
      onMouseDown={onClose}
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 999999,
        background: "rgba(15, 23, 42, 0.28)",
        backdropFilter: "blur(3px)",
        display: "flex",
        justifyContent: "flex-end"
      }}
    >
      <div
        onMouseDown={(e) => e.stopPropagation()}
        style={{
          width: `min(${width}px, 96vw)`,
          height: "100vh",
          background: "#f8fafc",
          borderLeft: "1px solid #e2e8f0",
          boxShadow: "-18px 0 40px rgba(15,23,42,0.16)",
          display: "flex",
          flexDirection: "column"
        }}
      >
        <div
          style={{
            padding: "18px 18px 16px",
            borderBottom: "1px solid #e2e8f0",
            background: "linear-gradient(180deg, #ffffff 0%, #f8fafc 100%)",
            display: "flex",
            justifyContent: "space-between",
            gap: 12,
            alignItems: "flex-start"
          }}
        >
          <div style={{ minWidth: 0 }}>
            {eyebrow ? (
              <div
                style={{
                  fontSize: 11,
                  fontWeight: 900,
                  textTransform: "uppercase",
                  letterSpacing: 0.6,
                  color: "#64748b",
                  marginBottom: 6
                }}
              >
                {eyebrow}
              </div>
            ) : null}

            <div
              style={{
                fontSize: 28,
                fontWeight: 900,
                color: "#0f172a",
                lineHeight: 1.04,
                letterSpacing: "-0.03em"
              }}
            >
              {title}
            </div>

            {subtitle ? (
              <div
                style={{
                  marginTop: 6,
                  fontSize: 14,
                  color: "#475569",
                  lineHeight: 1.45
                }}
              >
                {subtitle}
              </div>
            ) : null}
          </div>

          <button
            type="button"
            onClick={onClose}
            style={{
              borderRadius: 12,
              padding: "10px 14px",
              border: "1px solid #cbd5e1",
              background: "#ffffff",
              color: "#334155",
              fontWeight: 800,
              cursor: "pointer"
            }}
          >
            Cerrar
          </button>
        </div>

        <div
          style={{
            padding: 18,
            overflow: "auto",
            flex: 1
          }}
        >
          {children}
        </div>
      </div>
    </div>
  )
}